import { render, staticRenderFns } from "./withdrawalRule.vue?vue&type=template&id=6d0ac072&scoped=true"
import script from "./withdrawalRule.vue?vue&type=script&lang=js"
export * from "./withdrawalRule.vue?vue&type=script&lang=js"
import style0 from "./withdrawalRule.vue?vue&type=style&index=0&id=6d0ac072&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0ac072",
  null
  
)

export default component.exports